import React, { useState, useEffect } from "react";
import axiosInstance from "../../axiosConfig";
import { Link, useParams } from "react-router-dom";
import "./Forum.css";

const Forum = ({ isGeneral = false }) => {
  const { stateCode } = useParams(); // Only applicable for state-specific forums
  const [posts, setPosts] = useState([]);
  const [newPost, setNewPost] = useState({ title: "", content: "" });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchPosts();
  }, [stateCode, isGeneral]);

  const fetchPosts = async () => {
    setIsLoading(true);
    try {
      const endpoint = isGeneral
        ? "/api/messageboard/forums/general/"
        : `/api/messageboard/forums/${stateCode}/`;
      const response = await axiosInstance.get(endpoint);
      setPosts(response.data);
      setIsLoading(false);
    } catch (err) {
      setError("Failed to fetch posts.");
      setIsLoading(false);
    }
  };

  const handleNewPostSubmit = async (e) => {
    e.preventDefault();
    try {
      const endpoint = isGeneral
        ? "/api/messageboard/forums/general/"
        : `/api/messageboard/forums/${stateCode}/`;
      await axiosInstance.post(endpoint, newPost);
      setNewPost({ title: "", content: "" });
      fetchPosts(); // Refresh posts after submission
    } catch (err) {
      setError("Failed to create post.");
    }
  };

  return (
    <div className="forum-container">
      <h1>{isGeneral ? "General Forum" : `${stateCode} Forum`}</h1>
      <div className="new-post-form">
        <h2>Create a New Post</h2>
        <form onSubmit={handleNewPostSubmit}>
          <input
            type="text"
            placeholder="Post Title"
            value={newPost.title}
            onChange={(e) => setNewPost({ ...newPost, title: e.target.value })}
            required
          />
          <textarea
            placeholder="Write your post here..."
            value={newPost.content}
            onChange={(e) => setNewPost({ ...newPost, content: e.target.value })}
            required
          ></textarea>
          <button type="submit">Submit</button>
        </form>
      </div>
      {isLoading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : posts.length === 0 ? (
        <p>No posts found. Be the first to create one!</p>
      ) : (
        <ul className="forum-posts-list">
          {posts.map((post) => (
            <li key={post.id} className="forum-post">
              <Link to={`/post/${post.id}`}>
                <h3>{post.title}</h3>
                <p>Posted by: {post.user.username}</p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Forum;
